module.exports = __webpack_public_path__ + "img/image35.8c31249c.png";